import React from 'react';
import { Reveal } from './ui/Reveal';
import { CheckCircle2 } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';
export function TestimonialsSection() {
  const {
    content
  } = useSiteContent();
  const testimonials = content.testimonials;
  return <section id="testimonios" className="py-24 px-6 md:px-16" data-id="element-1137">
      <div className="max-w-7xl mx-auto" data-id="element-1138">
        <Reveal className="text-center mb-16" data-id="element-1139">
          <span className="inline-block bg-sage-light/30 text-earth text-xs font-semibold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4" data-id="element-1140">
            {testimonials.sectionLabel}
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-earth mb-4" data-id="element-1141">
            {testimonials.sectionTitle}
          </h2>
          <p className="text-stone text-lg max-w-2xl mx-auto" data-id="element-1142">
            {testimonials.sectionSubtitle}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1143">
          {testimonials.items.map((t, i) => <Reveal key={i} delay={i * 100} data-id="element-1144">
              <div className="bg-white rounded-2xl p-6 border border-earth/10 shadow-sm h-full flex flex-col" data-id="element-1145">
                {/* Rating and verified badge */}
                <div className="flex items-center justify-between mb-4" data-id="element-1146">
                  <div className="flex items-center gap-0.5" data-id="element-1147">
                    {[...Array(t.rating)].map((_, i) => <span key={i} className="text-[#00B67A] text-lg" data-id="element-1148">
                        ★
                      </span>)}
                  </div>
                  {t.verified && <div className="flex items-center gap-1 text-[#00B67A] text-xs font-medium" data-id="element-1149">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-1150" />
                      <span data-id="element-1151">Verificado</span>
                    </div>}
                </div>

                {/* Review text */}
                <p className="text-stone text-sm leading-relaxed mb-6 flex-1" data-id="element-1152">
                  {t.quote}
                </p>

                {/* Author info */}
                <div className="pt-4 border-t border-earth/5" data-id="element-1153">
                  <div className="font-semibold text-sm text-earth mb-1" data-id="element-1154">
                    {t.author}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-stone/70" data-id="element-1155">
                    <span data-id="element-1156">{t.location}</span>
                    <span data-id="element-1157">•</span>
                    <span data-id="element-1158">{t.date}</span>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}